<div class="app-screen">
  <div class="app-screen--content">
    <div style="flex: 1 1 0;">
      <router-outlet></router-outlet>
    </div>

  </div>
  <div class="toast-container">
    @for (toast of toasts; track $index) {
      <app-toast
        [message]="toast.message"
        [type]="toast.type"
      ></app-toast>
    }
  </div>
</div>
